"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomButtonLoading = exports.CustomButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    buttonWrapper: {
      display: 'flex',
      borderStyle: 'solid !important',
      borderWidth: '0px 0px 1px 0px !important',
      borderColor: '#e1e2e1 !important',
      cursor: 'pointer'
    },
    textAndIconWrapper: {
      padding: '9px 9px 9px 21px',
      color: '#000000 !important',
      background: '#ffffff !important',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:hover': {
        background: '#fafafa !important'
      }
    },
    buttonWrapperLoader: {
      display: 'flex',
      borderStyle: 'solid !important',
      borderWidth: '0px 0px 1px 0px !important',
      borderColor: '#e1e2e1 !important'
    },
    textAndIconWrapperLoader: {
      padding: '9px 9px 9px 21px',
      color: '#000000 !important',
      background: '#ffffff !important',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
});

var CustomButton = function CustomButton(_ref) {
  var handleGoForward = _ref.handleGoForward,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleGoForward,
    className: classes.textAndIconWrapper
  }, /*#__PURE__*/_react.default.createElement("div", null, children), /*#__PURE__*/_react.default.createElement(_core.IconButton, null, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "arrow_forward_ios"))));
};

exports.CustomButton = CustomButton;

var CustomButtonLoading = function CustomButtonLoading() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonWrapperLoader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textAndIconWrapperLoader
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "text",
    height: 35,
    width: 100 + 250 * Math.random(100)
  })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "circle",
    height: 30,
    width: 30
  }))));
};

exports.CustomButtonLoading = CustomButtonLoading;